export default __webpack_public_path__ + "static/media/celular400.7fb689b9.png";